var exports = {
  "V": "x93eb46d8--747248--navigation-buttons-container",
};

module.exports = exports;
